import axios, { AxiosInstance } from 'axios';
import axiosRetry from 'axios-retry';
import { ConcurrencyManager } from './concurrency'

const instance = axios.create({
    baseURL: 'https://proxy.hermesmarketcap.com/'
}) as AxiosInstance;

ConcurrencyManager(instance, 5);
axiosRetry(instance, {
    retries: 3, retryDelay: (retryCount) => {
        return retryCount * 500;
    }
});

export default instance